module.exports = __webpack_public_path__ + "static/media/icon_copy.9f1a0b58.svg";